import { z } from "zod"

export const DownloadPriceListSchema = z.object({
  effectiveDate: z
    .string()
    .nullable()
    .refine((value): boolean => value?.trim() !== "" && value !== null, { message: "Effective date is required" }),
})

export type DownloadPriceListSchemaSchemaFormValues = z.infer<typeof DownloadPriceListSchema>
